export function goFullScreen() {
    let elem = document.documentElement;
    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        console.log("Already in fullscreen mode.");
        return;
      }    
    if (!document.fullscreenEnabled) {
      console.warn("Fullscreen API is not supported or blocked.");
      return;
    }
  
    if (elem.requestFullscreen) {
      elem.requestFullscreen()
        .then(() => console.log("Entered fullscreen mode"))
        .catch(err => {
          console.error("Fullscreen error:", err);
          alert("Fullscreen mode is blocked. Please allow it in your browser settings.");
        });
    } else if (elem.mozRequestFullScreen) { // Firefox
      elem.mozRequestFullScreen().catch(err => console.error("Fullscreen error:", err));
    } else if (elem.webkitRequestFullscreen) { // Chrome, Safari, Edge
      elem.webkitRequestFullscreen().catch(err => console.error("Fullscreen error:", err));
    } else if (elem.msRequestFullscreen) { // IE
      elem.msRequestFullscreen().catch(err => console.error("Fullscreen error:", err));
    }
  }
  export function exitFullScreen() {
    try {
      if (document.exitFullscreen) {
        document.exitFullscreen().catch(err => console.error("Fullscreen error:", err));;
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen().catch(err => console.error("Fullscreen error:", err));;
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen().catch(err => console.error("Fullscreen error:", err));;
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen().catch(err => console.error("Fullscreen error:", err));;
      }
    } catch (error) {
  
    }
  }

export const getUserIntegration = (userInfo) => {
  if (userInfo && userInfo.id) {
    if (userInfo.cleverId) {
      return "Clever"
    } else if (userInfo.canvas_id) {
      return "Canvas"
    } else if (userInfo.classlinkid) {
      return "Classlink"
    } else if (userInfo.schoologyid) {
      return "Schoology"
    } else if (userInfo.googleId) {
      return "Google Classroom"
    } else {
      return ""
    }
  }
}
export const getUserIntegrationType = (userInfo) => {
  if (userInfo && userInfo.id) {
    if (userInfo.cleverId) {
      return "clever"
    } else if (userInfo.canvas_id) {
      return "canvas"
    } else if (userInfo.classlinkid) {
      return "classlink"
    } else if (userInfo.schoologyid) {
      return "schoology"
    } else if (userInfo.googleId) {
      return "google"
    } else {
      return ""
    }
  }
}